module.exports = "/assets/data/1bc2f8def93a77e5d7544771362b252d-IV22.data.json";